export default __webpack_public_path__ + "static/media/sms_icon_blue.0146f958.svg";